import Vue from 'vue';
import FilePreview, { FilePreviewConfig } from 'file-preview';
import i18n from 'common-module/src/lang';

Vue.use<FilePreviewConfig>(FilePreview, {
  i18n,
  i18nResolver: (key: string, ...args: any[]) => Reflect.apply(i18n.t, i18n, [key, ...args]),
  i18nPluralizationResolver: (key: string, num: number, ...args: any[]) => Reflect.apply(i18n.tc, i18n, [key, num, ...args])
});
